 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"build/rockiot.chart":"build/rockiot.chart","build/rockiot.gauge.linear":"build/rockiot.gauge.linear","build/rockiot.gauge.radial":"build/rockiot.gauge.radial"}[chunkId]||chunkId) + "." + {"build/rockiot.chart":"ae5f0e3d","build/rockiot.gauge.linear":"0215b7fb","build/rockiot.gauge.radial":"39b8c333","chunk-05a4589e":"1ee25b8c","chunk-2d0c1b69":"e58955b8","chunk-2d0c577c":"fc08385c","chunk-2d213919":"4a49243f","chunk-45db2cb5":"d11ead28","chunk-5c7cca18":"ee8d5e1f","chunk-2d20f398":"e6d29462","chunk-d4ddf824":"bb5ba9dd","chunk-4abe6ea7":"fbd2ea4f","chunk-6db5e572":"7d11514c","chunk-774d3fe7":"c4b0618a","chunk-8966f794":"be977ec9","chunk-abec3648":"1b22b99c","chunk-e330a3f0":"ffe6c946","chunk-073d9257":"6333517f","chunk-0b49257f":"81e2bf59","chunk-0fb8aabc":"f6be6d37","chunk-1f851bd8":"dae1e84d","chunk-21f4aceb":"61243c97","chunk-267e4b78":"0f5696b0","chunk-2ae0cb5c":"33c9d4f2","chunk-0aeedb62":"2956b5c5","chunk-2d0aed56":"6596d9ba","chunk-2d0b9dd4":"6ddaaf56","chunk-2d22cc72":"eb69b4f6","chunk-410f9afb":"d5ec3d52","chunk-392e71f7":"2b1d3298","chunk-4bf9e280":"6ae06b12","chunk-565080d4":"3b331ddf","chunk-67bf3250":"c0f3c42c","chunk-696dd81d":"bb73f37e","chunk-6d5bd30b":"f7d67627","chunk-71a9abae":"dab4f822","chunk-78719b9c":"5c3a691b","chunk-7dfc893e":"1be51c68","chunk-94a49d98":"bbaf7525","chunk-a6d82ea0":"455f40d2","chunk-b08237ce":"d08e6b8a","chunk-eacbed86":"8ac17b25","chunk-f179e6d0":"7e03eb70","chunk-f7a9f640":"1758ec00","chunk-f9b4da6c":"01d3cd60","chunk-cba5a0f8":"68e78661"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"build/rockiot.gauge.linear":1,"chunk-05a4589e":1,"chunk-5c7cca18":1,"chunk-6db5e572":1,"chunk-8966f794":1,"chunk-2ae0cb5c":1,"chunk-0aeedb62":1,"chunk-410f9afb":1,"chunk-392e71f7":1,"chunk-cba5a0f8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"build/rockiot.chart":"build/rockiot.chart","build/rockiot.gauge.linear":"build/rockiot.gauge.linear","build/rockiot.gauge.radial":"build/rockiot.gauge.radial"}[chunkId]||chunkId) + "." + {"build/rockiot.chart":"31d6cfe0","build/rockiot.gauge.linear":"57afacfd","build/rockiot.gauge.radial":"31d6cfe0","chunk-05a4589e":"0f8b6c3b","chunk-2d0c1b69":"31d6cfe0","chunk-2d0c577c":"31d6cfe0","chunk-2d213919":"31d6cfe0","chunk-45db2cb5":"31d6cfe0","chunk-5c7cca18":"2b088935","chunk-2d20f398":"31d6cfe0","chunk-d4ddf824":"31d6cfe0","chunk-4abe6ea7":"31d6cfe0","chunk-6db5e572":"6eb8ecbb","chunk-774d3fe7":"31d6cfe0","chunk-8966f794":"78b606a5","chunk-abec3648":"31d6cfe0","chunk-e330a3f0":"31d6cfe0","chunk-073d9257":"31d6cfe0","chunk-0b49257f":"31d6cfe0","chunk-0fb8aabc":"31d6cfe0","chunk-1f851bd8":"31d6cfe0","chunk-21f4aceb":"31d6cfe0","chunk-267e4b78":"31d6cfe0","chunk-2ae0cb5c":"759b44fa","chunk-0aeedb62":"38a0af88","chunk-2d0aed56":"31d6cfe0","chunk-2d0b9dd4":"31d6cfe0","chunk-2d22cc72":"31d6cfe0","chunk-410f9afb":"74769ad1","chunk-392e71f7":"786c8c51","chunk-4bf9e280":"31d6cfe0","chunk-565080d4":"31d6cfe0","chunk-67bf3250":"31d6cfe0","chunk-696dd81d":"31d6cfe0","chunk-6d5bd30b":"31d6cfe0","chunk-71a9abae":"31d6cfe0","chunk-78719b9c":"31d6cfe0","chunk-7dfc893e":"31d6cfe0","chunk-94a49d98":"31d6cfe0","chunk-a6d82ea0":"31d6cfe0","chunk-b08237ce":"31d6cfe0","chunk-eacbed86":"31d6cfe0","chunk-f179e6d0":"31d6cfe0","chunk-f7a9f640":"31d6cfe0","chunk-f9b4da6c":"31d6cfe0","chunk-cba5a0f8":"e9d76d27"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
